import React, { memo, useState } from 'react'
import { TableCell, Button, TextField, ThemeProvider } from '@mui/material'
import { defaultGridButtonsTheme } from '../../../utils/reporting/muiThemeConfigs'

const getNumbers = (value) => value.replace(/[^\d]+/g, '')

const Pagination = ({ gotoPage, pages, style }) => {
    const fonts = {
        normal: '"Roboto","Helvetica","Arial",sans-serif',
    }
    const [value, setValue] = useState('')

    const handleSubmit = () => {
        let newValue = getNumbers(value)
        if (newValue > 0 && newValue <= pages) {
            gotoPage(newValue - 1)
        }
    }

    return (
        <ThemeProvider theme={defaultGridButtonsTheme}>
            <div style={style}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        height: '100%',
                        alignItems: 'center',
                        marginRight: 30,
                    }}
                >
                    <span style={{fontSize: 14}}>
                    Page:
                    </span>
                    <TextField
                        type="number"
                        variant="standard"
                        size="small"
                        onChange={(e) => setValue(e.target.value)}
                        value={value}
                        InputProps={{
                            style: {
                                fontFamily: fonts.normal,
                                fontSize: 14,
                                paddingLeft: 2,
                            },
                        }}
                        sx={{
                            width: 80,
                            marginLeft: 0,
                            marginRight: 2,
                            paddingLeft: 2,
                        }}
                    />
                    <Button
                        size="small"
                        onClick={handleSubmit}
                        variant="outlined"
                        color="primary"
                    >
                        Go
                    </Button>
                </div>
            </div>
        </ThemeProvider>
    )
}

export default memo(Pagination)
